module.exports = __webpack_public_path__ + "img/B3_HQ02.6d1b2dca.jpg";